import { render, staticRenderFns } from "./HistoricFilters.vue?vue&type=template&id=2bda73f0&scoped=true&"
import script from "./HistoricFilters.vue?vue&type=script&lang=ts&"
export * from "./HistoricFilters.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricFilters.vue?vue&type=style&index=0&id=2bda73f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda73f0",
  null
  
)

export default component.exports